import { useEffect, useState } from "react";
import { db } from "../firebase/firebaseConfig";
import { doc, getDoc} from 'firebase/firestore';
import { useNavigate } from "react-router-dom";

const useObtenerItems = (id)=>{
    const navigate = useNavigate();
    const [items, setItems] = useState([]);

    useEffect(()=>{
        const obtenerItems = async ()=>{
            const docum = await getDoc(doc(db,'itemsst', id));
            /* console.log(docum.data()) */
            if(docum.exists){
                setItems(docum.data());                
            }else{
                navigate('/serviciotecnico/itemsst');
            }
        }
        obtenerItems();
    },[navigate, id])

    return [items]
}

export default useObtenerItems;